document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector("scroll-carousel");
  const videos = document.querySelectorAll(".trending-video");
  let current = 0;
  let userInteracted = false;

  videos.forEach(v => v.muted = true);

  function scrollToVideo(index) {
    const target = videos[index];
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }

  function playVideo(index) {
    videos.forEach((v, i) => {
      v.pause();
      v.currentTime = 0;
      v.classList.toggle("active", i === index);
    });

    const video = videos[index];
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(err => {
        console.warn("Autoplay block:", err);
      });
    }

    scrollToVideo(index);
  }

  videos.forEach((video, i) => {
    video.addEventListener("ended", () => {
      current = (i + 1) % videos.length;
      playVideo(current);
    });
  });

  function startOnInteraction() {
    if (!userInteracted) {
      userInteracted = true;
      playVideo(current);
    }
  }

  ["click", "scroll", "keydown", "touchstart"].forEach(evt =>
    document.addEventListener(evt, startOnInteraction, { once: true })
  );
});